module.exports = __webpack_public_path__ + "media/images/webpage/hotels/743/plan3-1-bf40999e07336aad24091c250a2e5d66.webp";